<template>
  <div class="direction-wrap">
    <div class="list">
      <div class="group">
        <div class="title">什么是余额？</div>
        <div class="content">
          余额是当前用户的账户余额，可用于购买熊猫签证时进行金额减免，但不可提现，不可找零。
        </div>
      </div>

      <div class="group">
        <div class="title">如何积攒余额？</div>
        <div class="content">
          可通过邀请新用户购买熊猫签证服务获得余额奖励，每次成功邀请所得奖励余额请以实际规则为准。
        </div>
        <!--<a class="link" href="">马上去攒余额<span class="gt">＞</span><span class="gt">＞</span></a>-->
      </div>

      <div class="group">
        <div class="title">余额使用限制及退款相关规定？</div>
        <div class="content">
          余额仅可用于购买熊猫签证平台提供的服务与商品。如果支付时使用了余额，交易取消或被拒签，使用的余额仍会返回到您的余额账户。
        </div>
      </div>
    </div>

    <div class="footer">
      <br /><br />
      <div class="footer-2">Copyright© 熊猫签证 2016-2017, 版权所有</div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  name: 'moneyUsage',
  created() {
    utils.setTitle('余额使用说明');
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}

html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: white;
}

body {
  font-family: Segoe UI, Lucida Grande, Helvetica, Arial, Microsoft YaHei,
    FreeSans, Arimo, Droid Sans, wenquanyi micro hei, Hiragino Sans GB,
    Hiragino Sans GB W3, FontAwesome, sans-serif;
}

.direction-wrap {
  height: 100%;
  padding: 18px 0 0 0;
  background-color: white;
}

.list {
  padding: 0 11px;
  font-size: 16px;
  min-height: 100%;
  margin-bottom: -90px;
}

.list::after {
  content: '';
  display: block;
  height: 90px;
}

.list .group {
  margin-top: 30px;
}

.list .group:first-of-type {
  margin-top: 0;
}

.list .title {
  padding-left: 11px;
  color: #333;
  position: relative;
  line-height: 22px;
}

.list .title::before {
  background-color: #ff6f75;
  height: 15px;
  width: 3px;
  content: '';
  display: block;
  position: absolute;
  top: 4px;
  left: 0;
  border-radius: 2px;
}

.list .content {
  color: #909090;
  padding-left: 11px;
  line-height: 1.6;
  margin-top: 8px;
}

.list .link {
  color: #ff5a60;
  margin-left: 11px;
  margin-top: 8px;
  display: inline-block;
  text-decoration: none;
}

.list .gt {
  font-size: 14px;
}

.list .gt:first-of-type {
  margin-left: 2px;
}

.list .gt + .gt {
  position: relative;
  left: -7px;
  font-weight: bold;
}

.footer {
  color: #ff5a60;
  font-size: 14px;
  height: 40px;
  text-align: center;
  margin-top: 40px;
}

.footer-2 {
  color: #777;
  font-size: 12px;
}
</style>
